import { createContext, useContext } from 'react';
import type { FeatureFlagKey, FeatureFlagUser } from './registry';

export type FeatureFlagValues = Readonly<Record<FeatureFlagKey, boolean>>;
export type FeatureFlagContextValue = Readonly<{
  values: FeatureFlagValues;
  setUser: (user?: FeatureFlagUser) => void;
}>;

export const FeatureFlagsContext = createContext<FeatureFlagContextValue | undefined>(undefined);

export function useSetFeatureFlagUser(): (user?: FeatureFlagUser) => void {
  const context = useContext(FeatureFlagsContext);
  if (context === undefined) {
    throw new Error('useSetFeatureFlagUser must be used within FeatureFlagsProvider.');
  }
  return context.setUser;
}

export function useFeatureFlag(key: FeatureFlagKey): boolean {
  const context = useContext(FeatureFlagsContext);
  if (context === undefined) {
    throw new Error('useFeatureFlag must be used within FeatureFlagsProvider.');
  }
  return context.values[key];
}
